import { Button } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";
import { useNavigate } from "react-router-dom";

import { useTestAuthApi } from "@/lib/queries/use-test-auth-api";

export function Home() {
  const { isAuthenticated, hasPermission } = useAuth();
  const navigate = useNavigate();
  const testApiMutation = useTestAuthApi();

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-3xl font-bold">Hello Stardeck</h1>

      <div className="space-y-4">
        <div className="flex gap-4 items-center">
          <Button onClick={() => testApiMutation.mutate()} disabled={testApiMutation.isPending}>
            {testApiMutation.isPending ? "Testing..." : "Test Authenticated API"}
          </Button>
          {!isAuthenticated && (
            <span className="text-sm text-muted-foreground">(You'll need to log in first)</span>
          )}
        </div>

        {testApiMutation.data && (
          <div className="p-4 bg-muted rounded-lg">
            <h3 className="font-semibold mb-2">API Response:</h3>
            <pre className="text-sm overflow-auto">
              {JSON.stringify(testApiMutation.data, null, 2)}
            </pre>
          </div>
        )}

        {testApiMutation.error && (
          <div className="p-4 bg-destructive/10 rounded-lg">
            <h3 className="font-semibold mb-2 text-destructive">Error:</h3>
            <pre className="text-sm overflow-auto text-destructive">
              {testApiMutation.error.message}
            </pre>
          </div>
        )}
      </div>

      <div className="flex gap-4">
        {isAuthenticated && hasPermission("deployment:user:write") ? (
          <Button onClick={() => navigate("/dashboard")} variant="outline">
            Go to User Dashboard
          </Button>
        ) : (
          <Button onClick={() => navigate("/login")} variant="outline">
            Log In to User Dashboard
          </Button>
        )}
      </div>
      <div className="flex gap-4">
        {isAuthenticated && hasPermission("deployment:admin-panel:write") ? (
          <Button onClick={() => navigate("/admin")} variant="outline">
            Go to Admin Dashboard
          </Button>
        ) : (
          <Button onClick={() => navigate("/admin/login")} variant="outline">
            Log In to Admin Dashboard
          </Button>
        )}
      </div>
    </div>
  );
}
